import api from '../base';
import { GeneratedDocument, GeneratedDocumentType } from './generatedDocumentsApiTypes';
import { mockGetGeneratedDocuments } from './generatedDocumentsMock';

const BASE_PATH = 'management/generated-documents';

// eslint-disable-next-line import/prefer-default-export
export async function getGeneratedDocuments(
  type: GeneratedDocumentType,
  signal?: AbortSignal,
): Promise<GeneratedDocument[]> {
  const { data } = await api.get<GeneratedDocument[]>(
    BASE_PATH,
    { params: { type }, signal },
  );
  return data;
}

api.mock
  .onGet('management/generated-documents', { params: { type: GeneratedDocumentType.LISTING_REPORT_EXPORT } })
  .reply(202, mockGetGeneratedDocuments);
